import { Component, inject, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { faHandWave, faPhotoFilm } from '@fortawesome/pro-regular-svg-icons';

import { Media } from '@eiq/files/models';
import { ConfirmDialogComponent } from '@eiq/ui';

import { FileType } from '@empathy/global/data';
import { MediaForm } from '@empathy/survey-core';

import { IEditorForm } from '../../models/survey-editor/editor-form.interface';
import { TextEditorSettings } from '../../models/text-editor-settings.model';
import { StimulusPickerDialogComponent } from '../stimulus/stimulus-picker/stimulus-picker-dialog.component';

@Component({
  selector: 'empathy-welcome-page-form',
  templateUrl: 'welcome-page-form.component.html',
  styleUrls: ['./welcome-page-form.component.scss', './_welcome-page-form-theme.component.scss']
})
export class WelcomePageFormComponent {
  @Input() editorForm: FormGroup<IEditorForm>;

  faHandWave = faHandWave;
  faPhotoFilm = faPhotoFilm;

  inputSettings = new TextEditorSettings('input', false);
  textareaSettings = new TextEditorSettings('textarea', false);

  private dialog = inject(MatDialog);

  onAddStimulus(): void {
    const dialogRef = this.dialog.open(StimulusPickerDialogComponent, {
      data: {
        types: [FileType.ImageJpeg, FileType.ImagePng, FileType.ImageGif, FileType.VideoMp4],
        multipleInd: true
      }
    });

    dialogRef.afterClosed().subscribe((files: Media[]) => {
      if (files) {
        files.map((media) => new MediaForm(media).form).forEach((mediaForm) => (this.editorForm.get('welcomeStimulus') as FormArray).push(mediaForm));
      }
    });
  }

  onDeleteMedia(optionIndex: number): void {
    const confirmationRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Remove Stimulus',
        confirmText: 'Are you sure you want to remove this stimulus?',
        confirmBtn: 'Remove',
        color: 'warn'
      }
    });

    confirmationRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        (this.editorForm.get('welcomeStimulus') as FormArray).removeAt(optionIndex);
      }
    });
  }
}
